import lazyLoading from './lazyLoading'

export default {
  name: 'HomeNet Contact',
  path: '/homenet/contact',
  redirect: '/homenet/contact/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),
  children: [
    {
      'name': 'List',
      'path': 'list',
      'meta': {
        'label': 'List'
      },
      'component': lazyLoading('homenet/ContactList')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/contact.js